import type { PaletteOptions } from '@mui/material';
import { common } from '@mui/material/colors';
import { PaletteColor, alpha } from '@mui/material/styles';
import { error, info, neutral, success, warning } from '../colors';
import type { Contrast } from '../index';

interface Config {
  primaryColor?: PaletteColor;
  contrast?: Contrast;
}

export const createPalette = (config: Config): PaletteOptions => {
  const { primaryColor } = config;

  return {
    action: {
      active: neutral[500],
      disabled: alpha(neutral[900], 0.38),
      disabledBackground: alpha(neutral[900], 0.12),
      focus: alpha(neutral[900], 0.16),
      hover: alpha(neutral[900], 0.04),
      selected: alpha(neutral[900], 0.12)
    },
    background: {
      default: common.white,
      paper: common.white
    },
    divider: '#F2F4F7',
    error,
    info,
    mode: 'light',
    neutral,
    border: neutral[200],
    primary: primaryColor,
    secondary: {
      main: neutral[500]
    },
    success,
    text: {
      primary: neutral[900],
      secondary: neutral[500],
      disabled: alpha(neutral[900], 0.38)
    },
    warning
  };
};
